import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31888b2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "courseplay-container"
}
const _hoisted_2 = { class: "imgclass" }
const _hoisted_3 = {
  id: "J_prismPlayer",
  ref: "J_prismPlayer",
  class: "prism-player"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "study" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"#f16d3d"},
  class: "iconfont icon-duoren"
}, null, -1))
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "tab" }
const _hoisted_11 = { class: "first-tab" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "second-tab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_class_catalogue = _resolveComponent("class-catalogue")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_ctx.classDetail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_nav_bar, {
          "left-arrow": "",
          title: _ctx.$route.meta.title,
          placeholder: "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$route.query.videoId ? _ctx.$router.go(-3) : _ctx.$router.go(-1)))
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
            [_vShow, _ctx.$route.query.playAuth]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _ctx.classDetail.pictureUrl
          }, null, 8, _hoisted_4), [
            [_vShow, !_ctx.$route.query.playAuth]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.classDetail.name), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode("  " + _toDisplayString(_ctx.classDetail.learnUserNum) + "人已学习 ", 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.classDetail.createDate ? _ctx.classDetail.createDate.substr(0, 10) : ""), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_tabs, {
              active: _ctx.active,
              "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.active) = $event)),
              animated: "",
              swipeable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tab, { title: "简介" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.classDetail.name), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.classDetail.detail), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_tab, { title: "目录" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_class_catalogue, { "class-list": _ctx.classList }, null, 8, ["class-list"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["active"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}